var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M718.8,328.8c-12,0-21.6,9.6-21.6,21.6v72l190.8,0v-72c0-12-9.6-21.6-21.6-21.6L718.8,328.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.6,328.8c-12,0-21.6,9.6-21.6,21.6v72h190.8v-72c0-12-9.6-21.6-21.6-21.6H333.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.8,350.4c0-45.6,37.2-81.6,81.6-81.6H480c45.6,0,81.6,37.2,81.6,81.6v72H636v-72 c0-45.6,37.2-81.6,81.6-81.6h147.6c45.6,0,81.6,37.2,81.6,81.6v72h84l0-181.2c0-42-33.6-75.6-75.6-75.6l-712.8,0 c-42,0-75.6,33.6-75.6,75.6v181.2h84L250.8,350.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1161.6,714l-121.2-231.6H159.6L38.4,714c-6,10.8-8.4,22.8-8.4,34.8V1014c0,10.8,9.6,20.4,20.4,20.4H114 c10.8,0,20.4-9.6,20.4-20.4v-84h930v84c0,10.8,9.6,20.4,20.4,20.4h63.6c12,0,20.4-9.6,20.4-20.4l0-265.2 C1170,736.8,1167.6,724.8,1161.6,714L1161.6,714z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom);
export default __webpack_public_path__ + "static/media/Room.03a80c2e6fcd465df30e5c741f86fda8.svg";
export { ForwardRef as ReactComponent };